export default __webpack_public_path__ + "static/media/Sudhanshu_CV.3507ef41.pdf";